import { FormControl, FormLabel, Input, FormErrorMessage, Tooltip, useColorModeValue } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
const PrefixField = ({ value, onChange, error }) => {
  const labelColor = useColorModeValue('black', 'white');
   const { darkMode } = useSelector((state) => state.settings);
   
  return (
    <FormControl isInvalid={!!error} isRequired>
      <Tooltip label="Enter the prefix for this rate." placement="top">
        <FormLabel color={darkMode ? 'white' : 'black'}>Prefix</FormLabel>
      </Tooltip>
      <Input
        name="prefix"
        value={value}
        onChange={onChange}
        placeholder="Prefix"
        style={{
                 background: darkMode ? '#1e2021' : 'white',
                      color: `${darkMode ? '#f5f4f3' : 'inherit'}`,
          borderColor: `${darkMode ? '#565557' : '#007bff'}`
               }}
      />
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
};

export default PrefixField;
